import { ChangeDetectionStrategy, Component, EventEmitter, input, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AddDestinationAlternateFormComponent } from '@components/add-destination-alternate-form/add-destination-alternate-form.component';
import { AddDestinationFormComponent } from '@components/add-destination-form/add-destination-form.component';
import { CheckerError } from '@components/storage-accounts/add-storage-account-wizard/add-storage-account-wizard.constants';
import { alternateDestinationFormStorageTypes } from '@models/storage-accounts/storages.constants';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, MbsPopupType } from 'mbs-ui-kit';
import { StorageType } from 'mbs-ui-shared';
import { BucketInfo, StorageAccountV2 } from 'mbs-ui-shared/src/lib/models/StorageAccount';
import { HelpLinkDirective } from 'mbs-ui-shared@help/helpLink.directive';

@Component({
  selector: 'mbs-set-destination-step',
  templateUrl: './set-destination-step.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AddDestinationAlternateFormComponent, AddDestinationFormComponent, AlertComponent, I18NextPipe, HelpLinkDirective]
})
export class SetDestinationStepComponent {
  protected readonly checkerError = CheckerError;

  public readonly mbsPopupType = MbsPopupType;
  public readonly storageType = StorageType;
  public readonly alternateFormStorageTypes = alternateDestinationFormStorageTypes;

  @Output() currentBucketChanged = new EventEmitter<BucketInfo>();
  @Output() bucketLoadingChanged = new EventEmitter<boolean>();
  @Output() tryAgain = new EventEmitter<void>();
  @Output() reportIssue = new EventEmitter<void>();

  @Input() form: FormGroup;
  @Input() createNew: FormControl;
  @Input() storageAccount: StorageAccountV2;
  @Input() bucketTypeName: string;
  @Input() isDraftAccount = true;
  @Input() companiesLocked = false;
  @Input() selectedCompanyIds: string[] = [];
  @Input() hideCompanies = false;
  @Input() error: string;
  compatibleError = input<{
    type: CheckerError;
    text: string;
  }>();
}
